import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component, ViewChild} from "@angular/core";
import {ConfigurationService, NumberUtils, provideEntityModel} from "@fedeltapointofsale/data-client";
import {CashManagementEntityModel} from "../cash-management-entity.model";
import {FUIAlertActions, FUIAlertService, FUIModalsService, FUIResponsiveService} from "@fedeltapointofsale/ui";
import {CashManagementEditCashCalcComponent} from "./cash-management-edit-cash-calc/cash-management-edit-cash-calc.component";
import {ActionEvent} from "../../../framework/entity/action.event";
import {EditPageComponent} from "../../../framework/entity/edit/edit-page/edit-page.component";
import {ServerAuth} from "../../../config";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";

@Component({
    selector: "cash-management-edit-page",
    templateUrl: "./cash-management-edit-page.component.html",
    providers: [provideEntityModel(CashManagementEntityModel)]
})
export class CashManagementEditPageComponent extends AbstractEditPage {
    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: CashManagementEntityModel,
                private modalsService: FUIModalsService,
                private alertService: FUIAlertService,
                private configService: ConfigurationService,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
        this.model.$data.subscribe(() => {
            if (this.model.data.till.firstBalanceDate) {
                this.configService.getBoolean(ServerAuth.REBALANCE_TILL).then((authorised) => {
                    if (!authorised) {
                        setTimeout(() => this.editPageComponent.setReadOnly());
                    }
                });
            }
        });
    }

    openCalculator(): void {
        setTimeout(() => this.editGridComponent.cancelEditing());
        this.modalsService.create(CashManagementEditCashCalcComponent).subscribe(modal => {
            modal.till = this.model.data.till;
            if (this.model.readonly) {
                modal.setReadonly();
            }
            modal.onConfirm.subscribe((total) => {
                this.model.data.till.balancedTenders[0].userTotal = total;
            });
        });
    }

    calculateTotal(): number {
        return this.model.data.till.balancedTenders.map(value => value.userTotal).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    }

    saving(actionEvent: ActionEvent): void {
        const totalTill: number = this.calculateTotalTally();

        if (totalTill !== 0 && this.calculateTotal() !== totalTill) {
            actionEvent.preventDefault();
            this.alertService.showConfirmationOkCancel("wbo.cash-management.edit.prompt.totalCashDoesNotMatchTally.heading",
                "wbo.cash-management.edit.prompt.totalCashDoesNotMatchTally.message").subscribe((action) => {
                if (action === FUIAlertActions.OK_ACTION) {
                    this.clearTally();
                    this.editPageComponent.save();
                }
            });
        }
    }

    calculateTotalTally(): number {
        let total: number = 0;
        CashManagementEditCashCalcComponent.definitionValues.forEach(value => {
            total += NumberUtils.roundValue((this.model.data.till[value.name] | 0) * value.coefficient, 2);
        });
        return NumberUtils.roundValue(total, 2);
    }

    clearTally(): void {
        CashManagementEditCashCalcComponent.definitionValues.forEach(value => this.model.data.till[value.name] = 0);
    }
}
